export enum LiveTileTexts {
    TITLE = 'Live',
    LABEL_ENERGY_SAVER = 'Energiesparmodus',
}
